//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//api
import { carsResponse } from "./type/CarsType";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const GetBestCars = async () => {
    const response = await axios.get<carsResponse>(`${baseURL}/cars/best`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
      },
    });
    return response.data;
}